module.exports = __webpack_public_path__ + "static/media/countdownP2.09940c15.png";